import * as React from "react"

const SvgAlertTriangle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.725 21.714a.97.97 0 0 1-.85-.5 1.1 1.1 0 0 1-.137-.487.9.9 0 0 1 .137-.513l9.25-16a1 1 0 0 1 .387-.375q.238-.125.488-.125t.488.125a1 1 0 0 1 .387.375l9.25 16q.15.25.137.513a1.1 1.1 0 0 1-.137.487.97.97 0 0 1-.85.5zm1.725-2h15.1l-7.55-13zm7.55-1a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712.97.97 0 0 0 .287.713q.288.288.713.287m0-3q.424 0 .713-.287a.97.97 0 0 0 .287-.713v-3a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v3a.97.97 0 0 0 .287.713q.288.287.713.287" />
  </svg>
)
export default SvgAlertTriangle
